


































































































import { Component, Ref, Vue } from 'vue-property-decorator';
import {
  ManagementServicesItem,
  ManagementServicesItemImpl, ManagementServicesPartnerItem,
} from '@/store/mail_notify/management_services/types';
import {Action, Getter} from 'vuex-class';
import {cloneDeep, isEqual} from "lodash";
import { notifyError, notifyDelete, notifyConfirm } from '@/utils/notify-helper';
import {SelectWings} from "wings-ui-components";
import {PartnerItem} from "@/store/settings/partners/types";
import { MsgTransports } from '@/store/types';
import {ActionLog} from "@/store/auth/types";
import {getTranslatedParams} from "@/utils/notify-utils";

@Component({components: {SelectWings}})
export default class MNManagementService extends Vue {
  @Ref('validator') validator: any;

  @Getter("partners") partnersList: any;

  @Action("getManagementServicesItem") actionGetItem: any;
  @Action("saveManagementServicesItem") actionSaveItem: any;
  @Action("deleteManagementServicesItem") actionDeleteItem: any;
  @Action("getPartners") actionGetPartners: any;
  @Action("getServiceProviders") actionGetServiceProviders: any;
  @Action("actionLog") actionLog: any;

  item = this.defaultItem();
  itemSaved = this.defaultItem();
  private logObject: ActionLog = {};

  params = {transport: MsgTransports.MAILNOTIFY};
  serviceProvidersList:  any = []

  defaultItem(): ManagementServicesItem {
    return new ManagementServicesItemImpl();
  }

  async getServiceProvidersList(filter: any) {
    const items = await this.actionGetServiceProviders({...this.params, ...filter});
    this.serviceProvidersList = (filter?.page_number > 1) ? this.serviceProvidersList.concat(items) : items
  }

  async created() {
    await this.actionGetPartners({...this.params, page_size: 1000000});

    // TODO это логику надо будет изменить изменив partner_ids на partners
    const partners: ManagementServicesPartnerItem[] = this.partnersList
        .map((p: PartnerItem) => { return {id: p.id, allowed: false, partner_name: p.name}});
    this.item.partners = partners;
    this.itemSaved.partners = partners;

    if (this.$route.params.id) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Viewing",
          action_status: "success",
          object_type: "Mail Notify service",
          object_name: this.item.mn_service_name,
          addititional_info: getTranslatedParams(this.item)
        }
        const data = await this.actionGetItem(this.$route.params.id);
        await this.actionLog(this.logObject);
        this.item = Object.assign({}, this.item, data);
        this.itemSaved = cloneDeep(Object.assign({}, this.item, data));
        // TODO это логику надо будет изменить изменив partner_ids на partners
        this.item.partners.forEach((e:any, index)=>{
          if (this.item.partner_ids.includes(Number(e.id))){
            this.item.partners[index].allowed = true;
          }
        })
      } catch(error) {
        this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
        this.back();
      }
      this.serviceProvidersList = await this.actionGetServiceProviders({id: this.item.service_provider_id});
    }
  }

  back(): void {
    this.$router.push('/mail_notify/management_services/');
  }

  onSaveItem(): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      let valid: boolean = await this.validator.validate();
      if (valid) {
        try {
          this.logObject = {
            action_page: this.$route.meta.msgKey,
            action: this.$route.params.id ? "Editing" : "Creation",
            action_status: "success",
            object_type: "Mail Notify service",
            object_name: this.item.mn_service_name,
            addititional_info: getTranslatedParams(this.item)
          }
          this.item.partner_ids = this.item.partners.filter(p => p.allowed).map(p => p.id);
          await this.actionSaveItem(this.item);
          await this.actionLog(this.logObject);
          this.itemSaved = this.item;
          resolve()
          this.back();
        } catch (error) {
          await this.actionLog({...this.logObject, action_status: "failed"});
          reject()
          notifyError(error);
        }
      } else {
        setTimeout(() => {
          notifyError(null, this.validator.errors)
        }, 100);
      }
    })
  }

  onDeleteItem(): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      let isConfirm: boolean = await notifyDelete();
      if (isConfirm) {
        try {
          this.logObject = {
            action_page: this.$route.meta.msgKey,
            action: "Removal",
            action_status: "success",
            object_type: "Mail Notify service",
            object_name: this.item.mn_service_name,
            addititional_info: getTranslatedParams({id: this.item.id})
          }
          await this.actionDeleteItem(this.item);
          await this.actionLog(this.logObject);
          this.itemSaved = this.item;
          resolve();
          this.back();
        } catch (error) {
          await this.actionLog({...this.logObject, action_status: "failed"});
          reject();
          notifyError(error);
        }
      }
    });
  }

  beforeRouteLeave(to:any, from:any, next:any) {
    let isChange = !isEqual(this.item, this.itemSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }

  get status():number {
    return this.item.status
  }

  set status(value:number) {
    this.item.status = (value ?? 0)
  }

};
